/**
 * Read-only tax household access for inconsistency analysis.
 */
const getApplicationRoot = data =>
    (data?.singleStreamlinedApplication ? data.singleStreamlinedApplication : data);

export const resolveTaxHouseholdReadOnly = data => {
    const root = getApplicationRoot(data);

    if (!root?.taxHousehold) {
        return null;
    }

    const taxHousehold = Array.isArray(root.taxHousehold)
        ? root.taxHousehold[0]
        : root.taxHousehold;

    if (!taxHousehold || !Array.isArray(taxHousehold.householdMember)) {
        return null;
    }

    return taxHousehold;
};
